import { CoreApiVersionPath, RosaCoreApiService } from '@/rosa';
import { inject, Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';
import type { Branding } from '../../../interfaces/Branding.interface';
import type { LegalDocumentsFiles } from '../general-conditions.interface';

@Injectable({
    providedIn: 'root'
})
export class AdvizeoCoreGeneralConditionsProvider {
    private _rosaCoreApiService = inject(RosaCoreApiService);

    acceptGeneralConditions$(branding: Branding | null): Observable<void> {
        return this._rosaCoreApiService.post<void>(`${CoreApiVersionPath.V3}legal-documents/opt-in`, { branding: branding?.rootUri });
    }

    revokeGeneralConditions$(): Observable<void> {
        return this._rosaCoreApiService.post<void>(`${CoreApiVersionPath.V3}legal-documents/opt-out`, {});
    }

    getLegalDocumentFiles$(branding: Branding | null): Observable<LegalDocumentsFiles> {
        return this._rosaCoreApiService
            .checkedGet(
                `/api/${CoreApiVersionPath.V3}legal-documents/files`,
                {
                    query: {
                        branding: branding?.rootUri,
                        fallBackLanguage: navigator.language.split('-')[0]
                    }
                },
                true
            )
            .pipe(
                map(legalDocumentFiles => {
                    return {
                        generalConditionUrl: legalDocumentFiles.generalCondition,
                        cookiePolicyUrl: legalDocumentFiles.cookiePolicy,
                        privacyPolicyUrl: legalDocumentFiles.privacyPolicy,
                        brandGeneralConditionsUrl: legalDocumentFiles.brandGeneralCondition,
                        accessibilityUrl: legalDocumentFiles.accessibilityUrl
                    };
                })
            );
    }
}
